import { numberWithCommas } from '../../../../../helpers';

export const formatAudioCount = (n: number) => `${numberWithCommas(n)} audio${n !== 1 ? 's' : ''}`;
